export const USER_ROLE_CONFIG = {
  ADMIN: {
    label: "Admin",
    tone: "blue",
  },
  OUTLET_MANAGER: {
    label: "Outlet Manager",
    tone: "green",
  },
  FINANCE_MANAGER: {
    label: "Finance Manager",
    tone: "orange",
  },
  DISPATCH_MANAGER: {
    label: "Dispatch Manager",
    tone: "orange",
  },
};

export const USER_ROLE_OPTIONS = Object.entries(USER_ROLE_CONFIG)
  .filter(([value]) => value !== "ADMIN")
  .map(([value, config]) => ({
    value,
    label: config.label
      .toLowerCase()
      .replace(/\b\w/g, (character) => character.toUpperCase()),
  }));

const SELLER_OUTLET_USER_ROLE_PREFIX = "SELLER_OUTLET_USER_";

export const normalizeUserRole = (role) => {
  const normalizedRole = String(role || "").trim().toUpperCase();

  return normalizedRole.startsWith(SELLER_OUTLET_USER_ROLE_PREFIX)
    ? normalizedRole.slice(SELLER_OUTLET_USER_ROLE_PREFIX.length)
    : normalizedRole;
};

export const getUserRoleConfig = (role) =>
  USER_ROLE_CONFIG[normalizeUserRole(role)] || null;
